import { render, staticRenderFns } from "./UserTableActions.vue?vue&type=template&id=f163cc98"
import script from "./UserTableActions.vue?vue&type=script&lang=js"
export * from "./UserTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports